"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _formContext = _interopRequireDefault(require("@micado-digital/react-form/context/formContext"));

var _Button = _interopRequireDefault(require("@micado-digital/react-form/Button"));

var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));

var _Message = _interopRequireDefault(require("@micado-digital/react-form/Message"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _de = _interopRequireDefault(require("../../../locals/de.json"));

var _en = _interopRequireDefault(require("../../../locals/en.json"));

var _FormContent = _interopRequireDefault(require("./FormContent.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormContent = function FormContent(_ref) {
  var lang = _ref.lang,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess;

  var _useContext = (0, _react.useContext)(_formContext.default),
      _useContext2 = _slicedToArray(_useContext, 1),
      formConfig = _useContext2[0];

  var _formConfig$errorFiel = formConfig.errorFields,
      errorFields = _formConfig$errorFiel === void 0 ? {} : _formConfig$errorFiel,
      formLocked = formConfig.formLocked,
      _formConfig$response = formConfig.response;
  _formConfig$response = _formConfig$response === void 0 ? {} : _formConfig$response;
  var data = _formConfig$response.data;

  var _ref2 = data || {},
      formState = _ref2.state;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      formMessageObj = _useState2[0],
      setFormMessageObj = _useState2[1];

  var css = (0, _FormContent.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default
    }
  });
  (0, _react.useEffect)(function () {
    if (formState === 0) {
      setFormMessageObj({
        message: l("reactLoginForm.forgotPassword.messages.success.reset"),
        type: "success"
      });

      if (onSuccess) {
        onSuccess(data);
      }

      return;
    }

    if (formState === 1) {
      handleError(l("reactLoginForm.forgotPassword.messages.error.captchaFailed"));
    }

    if (formState === 2) {
      handleError(l("reactLoginForm.forgotPassword.messages.error.invalidMail"));
    }

    if (formState === 3) {
      handleError(l("reactLoginForm.forgotPassword.messages.error.mailNotFound"));
    }

    if (!(0, _isEmpty.default)(errorFields)) {
      handleError(l("reactLoginForm.forgotPassword.messages.error.mandatory"));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [formConfig]);

  var handleError = function handleError(message) {
    setFormMessageObj({
      message: message,
      type: "error"
    });
    if (onError) onError(data);
    return;
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    name: "jsonResponse",
    type: "hidden",
    value: "1"
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["mail"],
    errorMessage: l("reactLoginForm.forgotPassword.messages.error.mail"),
    label: l("reactLoginForm.forgotPassword.labels.mail"),
    name: "mail",
    required: true,
    showDeleteValue: true,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: l("reactLoginForm.forgotPassword.buttons.reset"),
    locked: formLocked,
    ButtonProps: {
      color: "primary",
      size: "medium",
      variant: "contained"
    }
  })), (formMessageObj === null || formMessageObj === void 0 ? void 0 : formMessageObj.message) && (formMessageObj === null || formMessageObj === void 0 ? void 0 : formMessageObj.type) && /*#__PURE__*/_react.default.createElement(_Message.default, {
    text: formMessageObj.message,
    type: formMessageObj.type
  }));
};

var _default = FormContent;
exports.default = _default;